import React, { useRef } from "react";
import { modal2Actions } from "../../../context/actions/modal2Actions";
import useStore from "../../../context/useStore";
import useModalA11y from "./useModalA11y";
import "./custom-modal.scss";

const CustomModal2 = () => {
  const [state, dispatch] = useStore();
  const actions = modal2Actions(state, dispatch);
  const modalProps = state.modal2;
  const cardRef = useRef(null);

  const close = () => actions.updateModal({ isOpen: false, content: null });

  useModalA11y({
    isOpen: !!modalProps.isOpen,
    onClose: close,
    cardRef,
  });

  return (
    <div
      className="custom-modal-overlay"
      style={{
        display: modalProps.isOpen ? "flex" : "none",
        zIndex: "999999",
        ...modalProps.style,
      }}
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) close();
      }}
    >
      <div
        className="custom-modal-card"
        role="dialog"
        aria-modal="true"
        tabIndex={-1}
        ref={cardRef}
      >
        <div className="custom-modal-body">{modalProps.content}</div>
        <div className="custom-modal-footer">
          {modalProps.actions}
          <button onClick={close} className="btn btn-default">
            Fermer
            <i className="fa fa-times ml-2" aria-hidden="true" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomModal2;
